module.exports = __webpack_public_path__ + "media/images/ic-index-shipping-80df18d596777a4ffa784602c4692697.svg";